<template>
  <div v-loading="listContentLoading">
    <el-select
      class="search-el"
      size="mini"
      v-model="query.source"
      clearable
      placeholder="兑换码标识"
    >
      <el-option label="全部" value="">全部</el-option>
      <el-option label="taobao" value="taobao">taobao</el-option>
    </el-select>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.code"
      clearable
      placeholder="请输入兑换码"
    ></el-input>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.ver_code"
      clearable
      placeholder="请输入核销码"
    ></el-input>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.mobile_phone"
      clearable
      placeholder="请输入手机号"
    ></el-input>
    <el-input
      class="search-el"
      size="mini"
      v-model="query.course_title"
      clearable
      placeholder="请输入课程名称"
    ></el-input>
    <el-date-picker
      class="search-el"
      size="mini"
      v-model="query.date_timestamp"
      value-format="yyyy-MM-dd HH:mm:ss"
      type="datetimerange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="截止日期"
      :picker-options="pickerOptions"
      :default-time="['00:00:00', '23:59:59']"
    >
    </el-date-picker>
    <el-select
      class="search-el"
      size="mini"
      v-model="query.ver_code_state"
      clearable
      placeholder="全部核销码"
    >
      <el-option label="全部核销码" value="">全部核销码</el-option>
      <el-option label="正确核销码" value="1">正确核销码</el-option>
      <el-option label="错误核销码" value="2">错误核销码</el-option>
    </el-select>
    <el-button type="primary" size="mini" @click="getList()"> 查询</el-button>
    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0;"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          min-width="3%"
        ></el-table-column>
        <el-table-column
          prop="source"
          label="兑换码标识"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="code"
          label="兑换码"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="verification_code"
          label="核销码"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          prop="mobile_phone"
          label="手机号"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="title"
          label="课程名称"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column
          prop="user_time"
          label="兑换时间"
          align="center"
          min-width="8%"
        ></el-table-column>

        <el-table-column label="核销码错误" align="center" min-width="14%">
          <template slot-scope="{ row }">
            <div>
              <span
                v-if="row.verification_code_state == 1"
                style="color: #67c23a;"
                ><i class="el-icon-circle-check"></i> 正确</span
              >
              <span
                v-if="row.verification_code_state == 2"
                style="color: #af093b;"
                ><i class="el-icon-circle-check"></i> 错误</span
              >
              <span
                v-if="row.verification_code_state == 0"
                style="color: #909399;"
                ><i class="el-icon-circle-close"></i> 未核销
                <el-button
                  type="text"
                  size="mini"
                  style="margin-left: 5px;"
                  @click="setVerCodeState(row.id, 1)"
                  >正确</el-button
                >
                <el-button
                  type="text"
                  size="mini"
                  style="margin-left: 15px;"
                  @click="setVerCodeState(row.id, 2)"
                  >错误</el-button
                >
              </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getExchangeCoupon, setVerCodeState } from "@/api/coupon";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        source: "",
        code: "",
        ver_code: "",
        mobile_phone: "",
        course_title: "",
        ver_code_state: "",
      },

      listContentLoading: false,
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      getExchangeCoupon(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    setVerCodeState(id, status) {
      let statis_title = status == 1?'正确':'错误';

      this.$confirm("是否将核销码改为“"+statis_title+"”状态", "提醒", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        setVerCodeState({
          id: id,
          status: status,
        }).then((response) => {
          if (response.status == 2000) {
            this.getList();
            this.$message({
              showClose: true,
              message: "设置成功",
              type: "success",
            });
          }
        });
      });
    },
  },
  mounted() {},
};
</script>
